import React from 'react'
import ReactDOM from 'react-dom'
import LabelWithHelp from '../src/javascripts/label_with_help';
import ValidatedInput from '../src/javascripts/validated_input';
import Utilities from '../src/javascripts/utilities'
import * as yup from 'yup';

function RecoilVerdict(props) {
  let recoilEnergy = props.recoilEnergy;
  if (!Utilities.isNumeric(recoilEnergy)) {
    recoilEnergy = "--";
  } else {
    recoilEnergy = recoilEnergy.toFixed(1).toLocaleString() + " ft-lb";
  }
  return (
    <React.Fragment>
      <h5 className="text-uppercase text-center">Recoil Energy</h5>
      <h5 className="text-center">{ recoilEnergy }</h5>
    </React.Fragment>
  )
}

class Recoil extends React.Component {
  constructor(props) {
    super(props);
    this.handleRifleWeightChange = this.handleRifleWeightChange.bind(this);
    this.handleProjectileWeightChange = this.handleProjectileWeightChange.bind(this);
    this.handleProjectileVelocityChange = this.handleProjectileVelocityChange.bind(this);
    this.handleChargeWeightChange = this.handleChargeWeightChange.bind(this);
    this.handleFactorChange = this.handleFactorChange.bind(this);
    this.state = {
      rifleWeight: '',
      projectileWeight: '',
      projectileVelocity: '',
      chargeWeight: '',
      factor: 1.75,
      rifleWeightValidationError: '',
      projectileWeightValidationError: '',
      projectileVelocityValidationError: '',
      chargeWeightValidationError: '',
    };

    this.schema = yup.object({
      velocityA: yup.number()
        .required('Velocity is required')
        .typeError('Velocity must be a number')
        .positive('Velocity must be a positive number'),
      rifleWeight: yup.number()
        .required('Weight is required')
        .typeError('Weight must be a number')
        .positive('Weight must be a positive number'),
      chargeWeight: yup.number()
        .required('Weight is required')
        .typeError('Weight must be a number')
        .positive('Weight must be a positive number'),
      projectileWeight: yup.number()
        .required('Weight is required')
        .typeError('Weight must be a number')
        .positive('Weight must be a positive number'),
      projectileVelocity: yup.number()
        .required('Velocity is required')
        .typeError('Velocity must be a number')
        .positive('Velocity must be a positive number')
    });

  }

  // validates single field, eg: input = {muzzleVelocity: muzzleVelocity}, and sets error message
  validateField(input) {
    const path = Object.keys(input)[0];
    const errorMessageKey = path + "ValidationError";
    yup.reach(this.schema, path).validate(input[path])
    .then(function(value) {
      this.setState({[errorMessageKey]: null});
    }.bind(this))
    .catch(function(error) {
      this.setState({[errorMessageKey]: error.message});
    }.bind(this));
  }

  handleRifleWeightChange(rifleWeight) {
    this.validateField({rifleWeight: rifleWeight});
    this.setState({rifleWeight: rifleWeight});
  }
  handleProjectileWeightChange(projectileWeight) {
    this.validateField({projectileWeight: projectileWeight});
    this.setState({projectileWeight: projectileWeight});
  }
  handleProjectileVelocityChange(projectileVelocity) {
    this.validateField({projectileVelocity: projectileVelocity});
    this.setState({projectileVelocity: projectileVelocity});
  }
  handleChargeWeightChange(chargeWeight) {
    this.validateField({chargeWeight: chargeWeight});
    this.setState({chargeWeight: chargeWeight});
  }
  handleFactorChange(e) {
    this.setState({factor: e.target.value});
  }

  recoil(rifleWeight, projectileWeight, projectileVelocity, chargeWeight, factor) {
    if (Utilities.isNumeric(rifleWeight) && parseFloat(rifleWeight) !== 0.0 &&
        Utilities.isNumeric(projectileWeight) &&
        Utilities.isNumeric(chargeWeight) &&
        Utilities.isNumeric(factor)
      ){
      const freeRecoilEnergy = (rifleWeight/64.34)*((projectileWeight*projectileVelocity+chargeWeight*projectileVelocity*factor)/(7000.0*rifleWeight))**2.0;
      return freeRecoilEnergy;
    }
  }

  render() {
     const rifleWeight = this.state.rifleWeight;
     const projectileWeight = this.state.projectileWeight;
     const projectileVelocity = this.state.projectileVelocity;
     const chargeWeight = this.state.chargeWeight;
     const factor = this.state.factor;

     const rifleWeightValidationError = this.state.rifleWeightValidationError;
     const projectileWeightValidationError = this.state.projectileWeightValidationError;
     const projectileVelocityValidationError = this.state.projectileVelocityValidationError;
     const chargeWeightValidationError = this.state.chargeWeightValidationError;

    return (
      <React.Fragment>
        <div className="row pb-3">

          <div className="col-lg-6 pt-3 d-flex flex-column">
            <h5 className="text-uppercase text-center">Load Info</h5>
            <div className="card bg-primary h-100">
              <div className="card-body">
                <div className="form-group">
                  <LabelWithHelp tooltipContent="The weight of the bullet or shot in grains">Projectile Weight (gr)</LabelWithHelp>
                  <ValidatedInput value={projectileWeight} onValueChange={this.handleProjectileWeightChange} validationErrorMessage={projectileWeightValidationError}/>
                </div>
                <div className="form-group">
                  <LabelWithHelp tooltipContent="The muzzle velocity of the bullet or shot in fps">Velocity (fps)</LabelWithHelp>
                  <ValidatedInput value={projectileVelocity} onValueChange={this.handleProjectileVelocityChange} validationErrorMessage={projectileVelocityValidationError}/>
                </div>
                <div className="form-group">
                  <LabelWithHelp tooltipContent="The weight of the propellant charge in grains">Charge Weight (gr)</LabelWithHelp>
                  <ValidatedInput value={chargeWeight} onValueChange={this.handleChargeWeightChange} validationErrorMessage={chargeWeightValidationError}/>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 pt-3 d-flex flex-column">
            <h5 className="text-uppercase text-center ">Rifle Info</h5>
            <div className="card bg-primary h-100">
              <div className="card-body">
                <div className="form-group">
                  <LabelWithHelp tooltipContent="The weight of the rifle charge in pounds">Rifle Weight (lb)</LabelWithHelp>
                  <ValidatedInput value={rifleWeight} onValueChange={this.handleRifleWeightChange} validationErrorMessage={rifleWeightValidationError}/>
                </div>
                <div className="form-group">
                  <LabelWithHelp tooltipContent="Choose a firearm type. This determines the velocity of the propellant gases.">Scale Factor</LabelWithHelp>
                  <select className="form-control" value={factor} onChange={this.handleFactorChange}>
                    <option default value="1.75">Rifle</option>
                    <option value="1.5">Handgun</option>
                    <option value="1.5">Shotgun</option>
                    <option value="1.25">Shotgun, Long Barrel</option>
                  </select>
                </div>
              </div>
              <div className="card-footer bg-secondary">
                <RecoilVerdict recoilEnergy={ this.recoil(rifleWeight, projectileWeight, projectileVelocity, chargeWeight, factor) } />
              </div>
            </div>
          </div>

        </div>
      </React.Fragment>
    );
  }
}

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <Recoil />,
    document.getElementById('recoil')
  )
});